export * from './kunden-arts-sorter.component';
export * from './kunden-arts-sorter.component.module';